module.exports = __webpack_public_path__ + "assets/img/defaultheader.b830ab18.png";